import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import DialogModal from '../../../Modal/DialogModal/DialogModal';
import TabsWrapper from '../../../Tabs/TabsWrapper';
import TabGallery from '../../../Tabs/Components/TabGallery/TabGallery';
import './TourStopMediaGallery.scss';

class TourStopMediaGallery extends Component {
  render() {
    const {
      closeModal,
      stopImages = [],
      stopVideos = [],
      activeTab,
      primaryColor,
      stopName,
      isOpen,
      myRef,
      getMediaIndex,
      toggleActiveTab,
      t,
    } = this.props;
    const tabData = [
      {
        title: Boolean(stopImages.length) ? t('publicTour.media.images') : null,
        enabled: true,
        count: stopImages.length,
        Component: (
          <TabGallery
            media={stopImages}
            mediaLibrary
            getMediaIndex={getMediaIndex}
          />
        ),
      },
      {
        title: Boolean(stopVideos.length) ? t('publicTour.media.videos') : null,
        enabled: true,
        count: stopVideos.length,
        Component: (
          <TabGallery media={stopVideos} getMediaIndex={getMediaIndex} />
        ),
      },
    ];

    const mediaType = activeTab === 0 ? 'images' : 'videos';

    return (
      <React.Fragment>
        <DialogModal
          className="stop-media-gallery"
          closeModal={closeModal}
          isOpen={isOpen}
          shouldCloseOnOverlayClick
        >
          <h1 className="media-gallery-name" aria-label={`Additional ${mediaType} of ${stopName}`} tabIndex={0} ref={myRef}>
            {stopName}
          </h1>
          <TabsWrapper
            data={tabData}
            type="tab-gallery"
            activeTab={activeTab}
            primaryColor={primaryColor}
            width="15%"
            toggleActiveTab={toggleActiveTab}
          />
        </DialogModal>
      </React.Fragment>
    );
  }
}

export default withTranslation()(TourStopMediaGallery);
